import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Link,
} from "@mui/material";
import { useAuth } from "../../hooks/auth/AuthContext";

// Etapa de verificação em duas etapas (código enviado por e-mail).
// Mostrada no lugar do formulário de login quando o backend responde
// { mfa_required: true }.
export default function MfaStep() {
  const { verifyMfa, cancelMfa } = useAuth();
  const [code, setCode] = useState("");
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (code.length < 6) return;
    setLoading(true);
    try {
      await verifyMfa({ code, rememberDevice: remember });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        background: "#fdf9f0",
        minHeight: { xs: "auto", md: "70vh" },
        width: "100%",
        py: { xs: 4, md: 0 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: { xs: 3, sm: 4 },
          maxWidth: 420,
          width: "90%",
          borderRadius: 3,
          textAlign: "center",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, color: "#1A3C6B" }}>
          Verificação em duas etapas
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary", mt: 1, mb: 2 }}>
          Enviamos um código de 6 dígitos para o seu e-mail. Digite-o abaixo para
          concluir o login.
        </Typography>

        <form onSubmit={submit}>
          <TextField
            fullWidth
            autoFocus
            label="Código"
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
            inputProps={{
              inputMode: "numeric",
              maxLength: 6,
              style: {
                letterSpacing: "0.4em",
                textAlign: "center",
                fontSize: "1.4rem",
              },
            }}
          />
          <FormControlLabel
            sx={{ mt: 1 }}
            control={
              <Checkbox
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
              />
            }
            label="Lembrar este dispositivo por 30 dias"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={loading || code.length < 6}
            sx={{ mt: 2, py: 1.2, bgcolor: "#1A3C6B", "&:hover": { bgcolor: "#12305a" } }}
          >
            {loading ? (
              <CircularProgress size={22} sx={{ color: "#fff" }} />
            ) : (
              "Verificar e entrar"
            )}
          </Button>
        </form>

        <Link
          component="button"
          type="button"
          onClick={cancelMfa}
          sx={{ mt: 2, display: "inline-block", color: "#255aa7" }}
        >
          Voltar ao login
        </Link>
      </Paper>
    </Box>
  );
}
